// 다지점 공유 상품(#73·#98) 판매/이용지점 요약 라벨. 백엔드 BranchShareInfo(branchShare) 응답을 받는다.
// shared=false(비공유)면 빈 문자열 — 호출부는 기존 단일 지점 표시를 유지한다.
const summarize = names => {
  if (!names?.length) return '';
  return names.length === 1 ? names[0] : `${names[0]} 외 ${names.length - 1}개`;
};

export const saleBranchLabel = bs => {
  if (!bs?.shared) return '';
  return bs.saleAllDirectYn === 'Y' ? '전체 직영' : summarize(bs.saleBranchNames);
};

// 소속지점 모드: 상품 목록에서는 "소속지점", 회원 카드에서는 백엔드가 구매지점 1개를 채워 주므로 "옥수점(구매지점)"
export const usageBranchLabel = (bs, { forMember = false } = {}) => {
  if (!bs?.shared) return '';
  if (bs.useSaleBranchYn === 'Y') {
    return forMember && bs.useBranchNames?.length ? `${bs.useBranchNames[0]}(구매지점)` : '소속지점';
  }
  // 회원 카드는 이 회원권에서 수기로 뺀 지점이 있으면 '전체 직영'이 아니라 실제 지점명을 보여준다.
  if (forMember && bs.useBranchOptions?.length) {
    const kept = bs.selectedUseBranchIds?.length ?? bs.useBranchOptions.length;
    if (kept === bs.useBranchOptions.length && bs.useAllDirectYn === 'Y') return '전체 직영';
    return summarize(bs.useBranchNames);
  }
  return bs.useAllDirectYn === 'Y' ? '전체 직영' : summarize(bs.useBranchNames);
};

// 회원 카드에서 이용지점을 편집할 수 있는지 — 후보가 2개 이상일 때만 의미가 있다.
export const canEditUseBranches = bs => !!bs?.shared && (bs.useBranchOptions?.length ?? 0) > 1;
